<div>
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let item of breadcrumbList; let i = index">
      
      <ng-container *ngIf="item.en_fr; else recordView">
        <ng-container *ngIf="item.url_en == ''; else loadWebpage">
          <a [routerLink]="['/']">
            {{ item.en_fr | translate | async }}
          </a>
        </ng-container>
        <ng-template #loadWebpage>
          <ng-container *ngIf="this.languageService.languageType === 'en'; else frUrl">
            <a [href]="[item.url_en]">
              {{ item.en_fr | translate | async }}
            </a>
        </ng-container>
        <ng-template #frUrl>
          <a [href]="[item.url_fr]">
            {{ item.en_fr | translate | async }}
          </a>
        </ng-template>
        </ng-template>
      </ng-container>
      <ng-template #recordView>
        <a>
          {{ item.prefix | translate | async }} {{ item.name }}
        </a>
      </ng-template>

      <ng-container *ngIf="i < breadcrumbList.length - 1">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
          <use href="#ontario-icon-chevron-right"></use>
        </svg>
      </ng-container>
      
    </li>
  </ul>
</div>